import { render, staticRenderFns } from "./OrgCommunicationDefaults.vue?vue&type=template&id=8a54ee1c&scoped=true&"
import script from "./OrgCommunicationDefaults.vue?vue&type=script&lang=js&"
export * from "./OrgCommunicationDefaults.vue?vue&type=script&lang=js&"
import style0 from "./OrgCommunicationDefaults.vue?vue&type=style&index=0&id=8a54ee1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a54ee1c",
  null
  
)

export default component.exports